<template>
  <div class="project">
    <van-popup v-model="showPicker" position="bottom" close-on-popstate :style="{ height: '80%' }"
      :close-on-click-overlay="false">
      <div class="pop-wrapper">
        <div class="pop-title">请仔细阅读</div>
        <div class="pop-content">
          <div class="name">{{ groupDetail.tournamentRegionName || '' }}赛事沟通群</div>
          <div class="content">
            <p>请各位参赛选手务必微信扫码进群，后续大赛有相关文件和动态将在群里通知。</p>
            <!-- <p><img src="https://www.ttcdw.com.cn/storage/group1/M00/2C/1A/CgoAGGh0wPmAe73gAAJiXqZT_eU662.jpg" title=""
                alt="imgFile-c18768328490b8955eac35bfe2eccc94.jpg" width="393" height="483"></p> -->
            <p><img :src="base.resourceUrl + groupDetail.imageUrl || ''" alt="" width="393" height="483"></p>
          </div>
        </div>
        <div class="pop-footer">
          <div class="readed-btn">
            <van-button block type="info" size="large" @click="close" :disabled="countdown > 0"> {{ buttonText
            }}</van-button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import NavBar from 'vant/lib/nav-bar';
import 'vant/lib/nav-bar/style';
import Tabs from 'vant/lib/tabs';
import 'vant/lib/tabs/style';
import Tab from 'vant/lib/tab';
import 'vant/lib/tab/style';
import Button from 'vant/lib/button';
import 'vant/lib/button/style';
import Search from 'vant/lib/search';
import 'vant/lib/search/style';
import Dialog from 'vant/lib/dialog';
import 'vant/lib/dialog/style';
import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';
import { getInteractGroupDetail } from '@/api/activity'
import base from '@/api/base'
Vue.use(Search)
Vue.use(NavBar)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Button)
Vue.use(Popup)
export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      base: base,
      searchVal: '',
      showPicker: true,
      banner_bg: require("@/assets/img/bg-img/bg2.jpg"),
      activeTab: 0, // 必须为数字，0表示第一个标签[3,4](@ref)
      activeColor: "rgb(59, 112, 255)", // 直接写颜色值，无分号
      bgColor: "rgb(240, 240, 240)",    // 背景色示例（非必须）
      countdown: 10,  // 倒计时秒数
      timer: null,     // 定时器对象
      groupDetail: {}
    }
  },
  computed: {
    buttonText() {
      return this.countdown > 0
        ? `请阅读(${this.countdown}秒)`
        : '已阅，关闭';
    }
  },
  components: {
  },
  created() {
    if (this.$route.query.id) {
      getInteractGroupDetail({ id: this.$route.query.id }).then(resp => {
        this.groupDetail = resp.data
      }).catch(() => {
        this.groupDetail = {}
      })
    }
  },
  mounted() {
    document.title = '山西省第四届家庭教育指导技能大赛报名'
    this.startCountdown();  // 启动倒计时
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    close() {
      this.toPage('registrationends')
    },

    toPage(pageName) {
      this.$router.push({ name: pageName, query: { id: this.$route.query.id } })
    },
  },

}
</script>

<style lang="scss" scoped>
.project {
  height: 100%;

  .pop-wrapper {
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;

    .pop-title {
      margin: 21px 16px 0;
      border-bottom: 1px solid #eee;
      padding-bottom: 21px;
      font-size: 19px;
      font-weight: 500;
      color: #333;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
    }

    .pop-content {
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      padding: 16px;
      height: 15px;
      overflow-y: auto;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;

      .name {
        font-size: 19px;
        font-weight: 700;
        margin-bottom: 13px;
        text-align: center;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }

      .content {
        font-size: 15px;
        word-break: break-all;
        margin-bottom: 17px;
      }

      .pop-footer {
        margin: 11px 23px;

        .readed-btn {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
          -ms-flex-direction: row;
          flex-direction: row;
        }
      }

    }
  }
}
</style>
